// extracted by mini-css-extract-plugin
export default {"OrderError":"OrderError_OrderError__Z3doA"};